// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let RefreshTokenMesage = function (fieldSet)
{
    this.Code = Message.CODE_PFIX_REFRESH_TOKEN;
    PFixMessage.call(this, fieldSet);
}
RefreshTokenMesage.prototype = Object.create(PFixMessage.prototype);

RefreshTokenMesage.prototype.SetRefreshToken = function (token)
{
    this.setFieldValue(FieldsFactory.FIELD_REFRESH_TOKEN, token);
}
RefreshTokenMesage.prototype.GetRefreshToken = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_REFRESH_TOKEN);
}
RefreshTokenMesage.prototype.GetAccessToken = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN);
}
RefreshTokenMesage.prototype.GetAccessTokenLifeTime = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_ACCESS_TOKEN_LIFE_TIME);
}
RefreshTokenMesage.prototype.GetRefreshTokenLifeTime = function ()
{
    return this.getFieldValue(FieldsFactory.FIELD_REFRESH_TOKEN_LIFE_TIME);
}

//public TokenInfo GetTokenInfo() => new TokenInfo(this);

//public TokenInfo(PFixMessage messageWithTokens)
//{
//            this.recivedTime = DateTime.UtcNow;
//FieldsFactory factory = FieldsFactory.Instance;

//this.AccessToken = (string)messageWithTokens.getFieldValue(factory.FIELD_ACCESS_TOKEN);
//this.AccessTokenLifeTime = (long?)messageWithTokens.getFieldValue(factory.FIELD_ACCESS_TOKEN_LIFE_TIME);
//this.RefreshToken = (string)messageWithTokens.getFieldValue(factory.FIELD_REFRESH_TOKEN);
//this.RefreshTokenLifeTime = (long?)messageWithTokens.getFieldValue(factory.FIELD_REFRESH_TOKEN_LIFE_TIME);
//}
//}